import { SupportedChainId } from "./chains";

// export enum SupportedChainId {
//     MAINNET = 1,
//     GOERLI = 5,
//     KOVAN = 42,
  
//     ARBITRUM_ONE = 42161,
//     ARBITRUM_RINKEBY = 421611,
  
//     OPTIMISM = 10,
//     OPTIMISTIC_KOVAN = 69,
  
//     POLYGON = 137,
//     POLYGON_MUMBAI = 80001,
//   }

export const GRAPH_API_URL = {
    [SupportedChainId.MAINNET]: '',
    [SupportedChainId.GOERLI]: '',
    [SupportedChainId.CELO]: '',
    [SupportedChainId.ALFAJORES]: 'https://api.thegraph.com/subgraphs/name/supermutecx/double-alfajores-uniswap-v3',
    [SupportedChainId.AURORA]: '',
    [SupportedChainId.AURORA_TEST]: '',
    [SupportedChainId.KOVAN]: '',
    [SupportedChainId.POLYGON]: '',
    [SupportedChainId.POLYGON_MUMBAI]: '',
    [SupportedChainId.ARBITRUM_ONE]: '',
    [SupportedChainId.ARBITRUM_RINKEBY]: '',
    [SupportedChainId.OPTIMISM]: '',
    [SupportedChainId.OPTIMISTIC_KOVAN]: '',
  }